module.exports = __webpack_public_path__ + "static/media/amulet_03.78b7287c.png";